<template>
    <div class="header type-area">

        <router-link class="bigLogo" tag="div" :to="{ name:'Home' }">
          <div>
            <img class="logo" src="@/assets/images/logo.png" alt="">
            <span class="flash"/>
          </div>
        </router-link>

            <!--      一级-->
            <ul class="menu" v-for="(level1,index1) in $t('menu')" :key="index1">
              <router-link
                @click.native="clickLevel1($event)"
                :class="[{'en':$i18n.locale === 'en'},'level1']"
                tag="li"
                :to="{ name: level1.name }"
                >
                {{level1.level1}}

                  <!--      二级-->
                  <div class="menu-inside">
                    <ul class="menu2" v-for="(level2,index2) in level1.list1" :key="index2">
                      <router-link
                        :id="index2"
                        :class="[{'en':$i18n.locale === 'en'},'level2']"
                        tag="li"
                        :to=" { name: level2.name}">
                        {{level2.level2}}

                      <div class="menu-inside1">
                        <ul class="menu2 menu3" v-for="(level3,index3) in level2.list2" :key="index3">
                          <router-link
                            :id="index2"
                            :class="[{'en':$i18n.locale === 'en'},'level3']"
                            tag="li"
                            :to=" { name: level3.name}">
                            {{level3.level3}}
                          </router-link>
                        </ul>
                      </div>


                      </router-link>
                    </ul>
                  </div>

              </router-link>
            </ul>

      <div class="switch">
        <button :class="[{'lang-focus':$i18n.locale === 'cn'}, 'cn']" @click="switchCN()">中文</button>
        <button :class="[{'lang-focus':$i18n.locale === 'en'}, 'en']" @click="switchEN()">English</button>
      </div>


    </div>
</template>

<script>
import {setSession} from "../assets/commonjs/local";

export default {
  name: 'Header',
  data () {
    return {
      language:false,
    }
  },
  watch:{
    $route(to){
      this.routePath = to.path
      // console.log('1',to.path)
      // console.log('2',this.routePath)
    },
  },
  created() {
  },
  methods:{
    clickLevel1(e){
      if(this.$route.path.includes('BusinessLine')){
        let index = e.target.id ? e.target.id : 0
        this.Bus.$emit('id1',index)
        this.setSession('ID1',index)
      }
    },
    switchEN()  {
      this.$i18n.locale = 'en'
      // this.language = true;
      // this.Bus.$emit('language',this.language)
      // this.setSession('LANG',this.language)
    },
    switchCN()  {
      this.$i18n.locale = 'cn'
      // this.language = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .header{
     height: 89px;
  }
  .bigLogo{
    float: left;
    cursor: pointer;
    margin-top: 32px;
    overflow: hidden;
    div{
      position: relative;
      perspective: 300px;
      left: 0;
      top: 0;
    }
  }
  .flash{
    position: absolute;
    display: block;
    width: 3px;
    height: 50px;
    background: transparent;
    top: -15px;
    left: -28px;
    border-right: 5px solid #fff;
    border-left: 8px solid #fff;
    transform: rotateZ(45deg);
  }
  .bigLogo:hover .flash{
    animation: flash .7s linear;
  }
  @keyframes flash {
    0%{
      left: -28px;
    }
    100%{
      left: 180px;
    }
  }

  .menu{
    float: left;
    line-height: 89px;
    color:$fc-title
  }

  .switch{
    float: right;
  }

  //菜单
  .menu{
    color:$fc-title;
    margin:0 25px;
    cursor: pointer;
  }
  .menu:nth-of-type(1){
    margin-left: 118px;
  }
  .menu .level1{
     height: 89px;
     position: relative;
     text-align: center;
     box-sizing: border-box;
     font-size: 16px;
  }
  .menu .en{
    font-size: 14px;
  }
  .menu:hover .level1{
    color:$gc-embellish;
    border-bottom:3px solid $gc-embellish;
  }
  .menu .menu-inside,
  .menu .menu-inside1{
    position: absolute;
    white-space: nowrap;
    text-align: left;
    left: -34px;
    visibility: hidden;
    opacity: 0;
    z-index: 100;
    /*top:50px;*/
    background: #ffffff;
    transition: all .2s ease 0s;
  }
  .menu:hover .menu-inside,
  .menu2:hover .menu-inside1{
    visibility: visible;
    opacity: 1;
    /*top:89px;*/
  }
  .menu .menu-inside1{
    left: 101%;
    margin-top: -50px;
  }
  .menu2{
    height: 40px;
  }
  .menu2:hover{
    background: $gc-embellish;
  }
  .menu2 .level2,
  .menu2 .level3{
    line-height: 40px;
    color: $fc-title;
    font-size: 14px;
    padding: 0 25px;
  }
  .menu2 .en{
    font-size: 12px;
  }
  .menu2:nth-of-type(1){
       margin-top: 10px;
   }
  .menu2:nth-last-of-type(1){
    margin-bottom: 10px;
  }
  /*.menu3:nth-of-type(1){*/
  /*  margin-top: 10px;*/
  /*}*/
  /*.menu3:nth-last-of-type(1){*/
  /*  margin-bottom: 10px;*/
  /*}*/
  .menu2 .level2::before,
  .menu2 .level3::before{
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: $fc-title;
    margin-right: 9px;
    margin-bottom: 2px;
  }
  .level2:hover,
  .level3:hover {
    color: #ffffff;
  }
  .level2:hover::before,
  .level3:hover::before{
    background: #ffffff;
  }
  //语言切换
  .switch{
    border: 1px solid $gc-master;
    overflow: hidden;
    height: 32px;
    margin-top: 28px;
    border-radius: 4px;
  }
  .switch button{
    border: none;
    font-size: 14px;
    line-height: 34px;
    width: 71px;
    height: 100%;
    color: $gc-master;
    background: #fff;
    cursor: pointer;
  }
  .switch .cn{
    margin-right: -5px;
  }
  .switch .lang-focus{
    background: $gc-master;
    color: #fff;
  }


</style>



// WEBPACK FOOTER //
// src/components/Header.vue